import reducer, { saga as sagas, actions } from './ducks';
import * as translations from './translations';
import widgets from './widgets';

export const name = 'costItem';
export const realName = 'costItem';
export { reducer, widgets, sagas, actions, translations };
export * from './routes';
